module.exports = __webpack_public_path__ + "img/89.20d8c123.jpg";